import getOpenId from '../api/auth/get-open-id'
import router from '../router'
import {WECHAT_OPEN_ID} from '@store/mutation-types'
import {alert} from '@utils/dlg'
import {getLocalStorageItemOnce} from '@utils/api'

const RESULT_OK = 0
const RESULT_INVALID_CODE = 1

export default {
  beforeRouteEnter (to, from, next) {
    let code = to.query.code
    let state = to.query.state
    getOpenId(code, state, ({body: {result, msg, openid}}) => {
      switch (result) {
        case RESULT_OK:
          localStorage.setItem(WECHAT_OPEN_ID, openid)
          router.push({name: getLocalStorageItemOnce('leave_app_route')})
          break
        case RESULT_INVALID_CODE:
          alert(msg)
          break
      }
    }, (error) => {
      alert(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/wx-token-getter-2.js